import { Photo } from "nvent-web/types/Photo";

import Resource from "./Resource";

export default class PhotoResource extends Resource {
  create(projectId: number, roomId: number, photos: File[]) {
    const formPayload = new FormData();

    photos.forEach((photo) => formPayload.append("images[]", photo));

    return this.http.post<Photo[]>(`projects/${projectId}/rooms/${roomId}/photos`, formPayload);
  }

  delete(projectId: number, roomId: number, photoId: number) {
    return this.http.delete(`projects/${projectId}/rooms/${roomId}/photos/${photoId}`);
  }
}
